import { createSlice } from '@reduxjs/toolkit'
import Config from '../../Core/Config'

export const SET_SELECTED_DEVICES = 'ui/devices/setSelected'
export const UNSELECT_DEVICE = 'ui/devices/unselect'
export const ACTIVATE_SHORTCUT = 'ui/devices/activateShortcut'
export const DISACTIVATE_SHORTCUT = 'ui/devices/disactivateShortcut'

const devicesUiSlice = createSlice({
  name: 'devices',
  initialState: {
    selectedDevices: [],
    activeShortcut: null,
    menu: {
      expanded: Config.ui.defaultExpandedRightMenu,
    },
  },
  reducers: {
    init: (state) => {
      return { ...state, initing: true }
    },
    setSelectedDevices: (state, action) => {
      state.selectedDevices = action.payload
    },
    unselectDevice: (state, action) => {
      state.selectedDevices = state.selectedDevices.filter((d) => d.id !== action.payload.id)
    },
    activateShortcut: (state, action) => {
      state.activeShortcut = action.payload
    },
    disactivateShortcut: (state) => {
      state.activeShortcut = null
    },
    toggleMenuExpanded: (state) => {
      state.menu.expanded = !state.menu.expanded
    },
  },
})

export const { setSelectedDevices, unselectDevice, activateShortcut, disactivateShortcut, toggleMenuExpanded } =
  devicesUiSlice.actions
export default devicesUiSlice.reducer

export const selectSelectedDevices = (state) => state.ui.devices.selectedDevices
export const selectActiveShorcut = (state) => state.ui.devices.activeShortcut
export const selectMenuExpanded = (state) => state.ui.devices.menu.expanded
